import _ from 'lodash';

const StringColumnCSVFormatter = (cell) => (!_.isUndefined(cell) && !_.isNull(cell) ? cell : '-');
export default StringColumnCSVFormatter;
